
import React, { useEffect } from 'react';
import { Platform, SafeAreaView, Text, TouchableOpacity, View } from 'react-native';
import { SComponentContainer, SNavigation, STheme, SView } from 'servisofts-component2'
import Config from './Config';
import Pages from './Pages';
import SSocket, { setProps } from 'servisofts-socket';
import TopBar from './Components/TopBar';
import * as MDL from './MDL/index';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { SMapView } from 'servisofts-component2-smap';
import Popupsinicio from './Components/Popupsinicio';
import NavBar from './Components/NavBar';


SMapView.bootstrapURLKeys.key = "AIzaSyAr7BQ9lDDYgKUq2pIbvMRXS1HqFLI3gDw"
const store = {};
setProps(Config.socket);
const App = (props: any) => {
    useEffect(() => {
        MDL.componentDidMount()
        SNavigation.addOnChangeListener(e => {
            if (e.name != "/login") {
                // if (MDL.MDL.usuario.session == null) {
                //     SNavigation.reset("/login");
                //     return;
                // }
            }
            console.log("onChange", e);
        });

    }, [])

    return <GestureHandlerRootView style={{ flex: 1 }}>
        <SComponentContainer
            // inputs={Config.inputs}
            theme={{ themes: Config.theme, initialTheme: "dark" }}
        >
            <SNavigation
                linking={{
                    prefixes: ["https://calisteniabolivia.com/app/", "http://calisteniabolivia.com/app/", 'calisteniabolivia://app/'],
                    getInitialURL: () => {
                        // Firebase.getInitialURL();
                    }
                }}
                props={{
                    navBar: TopBar,
                    title: 'ROR Chofer', pages: Pages
                }}
            />
            <NavBar />
            {/* <SSocket
                store={store}
                identificarse={(props) => {
                    // var usuario = props.state.usuarioReducer.usuarioLog;
                    var usuario: any = MDL.MDL.usuario.session;
                    return {
                        data: usuario ? usuario : {},
                        deviceKey: "DeviceKey.getKey()",
                        firebase: {
                            platform: Platform.OS,
                            token: "DeviceKey.getKey()",
                            key_usuario: usuario?.key,
                            descripcion: Platform.select({
                                "web": `Web ${window.navigator.userAgent}`,
                                // @ts-ignore
                                "android": `Android ${Platform?.constants?.Version}, ${Platform?.constants?.Manufacturer} ${Platform?.constants?.Brand} ${Platform?.constants?.Model}`,
                                // @ts-ignore
                                "ios": `IOS ${Platform?.Version}, ${Platform?.constants?.systemName}`,
                            }),
                            app: "client"
                        }
                    };
                }}
            /> */}
            <Popupsinicio />
        </SComponentContainer>
    </GestureHandlerRootView>
}
export default App;